module.exports = __webpack_public_path__ + "img/ebook-hami.3114724d.png";